import { isBrowser, isNode } from '~src/env'
import { handleHttpError } from '~src/core/api/client'
import AsyncStoreBase from '~src/store/AsyncStoreBase'

import example from './example/example.store'
import errors from './errors/errors.store'

class RootStore extends AsyncStoreBase {
  constructor () {
    super()

    this.example = example
    this.errors = errors

    isBrowser && !isNode && this.init()
  }

  init () {
    this.setBusy(true)

    this.example
      .getThings()
      .then(() => {
        this.setBusy(false)
        this.setError()
      })
      .catch(err => {
        handleHttpError(err)
        if (err.request && err.request.status >= 500) {
          this.setError(err.message)
        }
        this.setBusy(false)
      })
  }
}

export default new RootStore()
